import type { GeminiVideoModelDefinition } from './video-model-types'

/** Canonical Gemini video catalog, including the Vertex model ID used by the adapter. */
export const GEMINI_VIDEO_MODEL_MANIFEST = {
  gemini_omni_flash: {
    provider: 'vertex',
    // Vertex serves Omni 1.1 only as a preview ID. The Gemini API's GA ID,
    // 'gemini-omni-1.1-flash', is rejected by Vertex's Interactions API, and
    // 'gemini-omni-flash-preview' is the older model that renders 720p only.
    providerModel: 'gemini-omni-1.1-flash-preview',
    modelName: 'Gemini Omni 1.1 Flash',
    description: 'Fast video generation and cinematic editing.',
    isPreview: true,
    capabilities: {
      modes: ['text', 'frames', 'references', 'edit', 'extend'],
      durations: { min: 3, max: 10, step: 1 },
      aspectRatios: ['16:9', '9:16'],
      resolutions: ['360p', '720p', '1080p', '4k'],
      supportsLastFrame: true,
      supportsAudio: true,
      audioMode: 'included',
      supportsNegativePrompt: false,
      promptMaxLength: 15000,
      inputAspectRatio: { min: 0.5, max: 2 },
      referenceLimits: { images: 10, videos: 3, audio: 0, maxVideoSeconds: 3 },
      referenceLimitsByMode: {
        frames: { images: 10, videos: 3, audio: 0, maxVideoSeconds: 3 }
      },
      maxTotalMediaBytes: 70 * 1024 * 1024,
      maxSourceVideoSeconds: 10,
      reusesOwnSourceOutput: true
    },
    providerRatios: {
      '360p': {},
      '480p': {},
      '720p': {},
      '1080p': {},
      '4k': {}
    },
    pricing: {
      // https://cloud.google.com/model-garden/pricing (checked 2026-11-04).
      // 1,931 / 5,792 / 8,688 / 17,376 output tokens per second at $17.50 per 1M, including audio.
      estimatedCostPerSecondUsdByResolution: {
        '360p': 0.0337925,
        '720p': 0.10136,
        '1080p': 0.15204,
        '4k': 0.30408
      },
      // 1,120 tokens per image at $1.50 per 1M input tokens.
      estimatedImageInputCostUsd: 0.00168
    }
  }
} as const satisfies Readonly<Record<string, GeminiVideoModelDefinition>>
